(function(app, $) {
    var $cache = {},
        productFilter = '*';

    function initializeCache() {
        $cache.body = $('body');
        $cache.window = $(window);
        $cache.productFiltersCtnr = $cache.body.find('div.catalog-filters');
        $cache.productFiltersList = $cache.productFiltersCtnr.find('ul');
        $cache.productFilters = $cache.productFiltersList.find('li a');
        $cache.productFiltersMobile = $cache.productFiltersCtnr.find('select');
        $cache.productCtnr = $cache.body.find('div.products');
        $cache.productLoader = $cache.productCtnr.find('span.loader');
        $cache.productGrid = $cache.productCtnr.find('div.grid');
        $cache.productGridItems = $cache.productGrid.find('div.grid-item');

        // Menus
        $cache.menuDialogCtnr = $cache.body.find('div#menu-dialog');
        $cache.menuLinks = $cache.productGridItems.find('span.menu-open');
    }

    function reloadProductGrid() {
        var $firstGridItem = $cache.productGridItems.first();
        $cache.productGrid.find('div.grid-item').css('height', $firstGridItem.outerWidth() + 'px');

        $cache.productGridItems.each(function() {
            var $self = $(this);
            var $productNameCtnr = $self.find('div.productname-ctnr');
            var $menuNameCtnr = $self.find('div.menuname-ctnr');
            var productNameCtnrHeight = $productNameCtnr.outerHeight();
            var menuNameCtnrHeight = $menuNameCtnr.outerHeight();

            if($productNameCtnr.length > 0) {
                $productNameCtnr.css('margin-top', '-' + (productNameCtnrHeight / 2) + 'px');
            }

            if($menuNameCtnr.length > 0) {
                $menuNameCtnr.css('margin-top', '-' + (menuNameCtnrHeight / 2) + 'px');
            }
        });
    }

    function initializeProductGrid() {
        // Initialize isotope
        $cache.productGrid.isotope({
            itemSelector : '.grid-item',
            layoutMode   : 'fitRows',
            filter       : productFilter
        });
    }

    function initializeEvents() {
        // Start, hide the product grid and display a loader while all products are loaded
        $cache.productGrid.hide();
        $cache.productCtnr.css('height', '500px');
        $cache.productLoader.show();

        var timeoutResize;
        $cache.window.resize(function() {
            if(typeof timeoutResize !== 'undefined') {
                clearTimeout(timeoutResize);
            }
            timeoutResize = setTimeout(function() {
                reloadProductGrid();
            }, 50);
        });

        // Desktop filters
        $cache.productFilters.on('click', function(e) {
            e.preventDefault();

            var $self = $(this);
            var filter = '.' + $self.attr('data-filter');

            buildProductFilter(filter, $self.parent().hasClass('active'));
            $self.parent().toggleClass('active');
        });

        // Mobile filters
        $cache.productFiltersMobile.on('change', function() {
            var $self = $(this);
            var filter = $self.find('option:selected').val();
            if(filter !== "*") {
                filter = '.' + filter;
            }

            buildProductFilter(filter, null, true);
        });

        // Click on "view details" link for menus
        $cache.menuLinks.on('click', function() {
            var $self = $(this);
            var $menuTitle = $self.attr('data-menu-title');
            var $menuBody = $self.parents('div.grid-item').find('div.menubody').html();

            if($menuTitle.length > 0 && $menuBody.length > 0) {
                $cache.menuDialogCtnr.attr('title', $menuTitle);
                $cache.menuDialogCtnr.html($menuBody);
                $cache.menuDialogCtnr.dialog({
                    position             : {
                        my        : "bottom",
                        at        : "center",
                        of        : window,
                        collision : "none"
                    },
                    windowScrollDisabled : true,
                    draggable            : false,
                    modal                : true,
                    closeOnEscape        : true,
                    resizable            : false,
                    width                : app.device.isMobile ? 300 : 500,
                    dialogClass          : 'menu-body-dialog',
                    open                 : function(event, ui) {
                        $(this).removeClass('hidden');
                    },
                    close                : function(event, ui) {
                        var $self = $(this);
                        $self.addClass('hidden').attr('title', '').html('');

                        try {
                            $self.dialog('destroy');
                        }
                        catch(e) {
                        }
                    }
                });
            }
        });
    }

    function buildProductFilter(filter, isActive, isMobile) {
        isActive = isActive || false;
        isMobile = isMobile || false;

        if(isMobile) {
            productFilter = filter;
        }
        else {
            if(isActive) {
                if(productFilter === filter) {
                    productFilter = '*';
                }
                else {
                    productFilter = productFilter.replace(', ' + filter, '').replace(filter + ', ', '');
                }
            }
            else {
                if(productFilter === '*') {
                    productFilter = filter;
                }
                else {
                    productFilter += (', ' + filter);
                }

            }
        }

        initializeProductGrid();
    }

    app.components = app.components || {};
    app.components.products = {
        init : function() {
            initializeCache();

            if($cache.productGrid.length > 0) {
                initializeEvents();

                // Then, when the window is loaded, let's display products
                $cache.productCtnr.css('height', 'auto');
                $cache.productGrid.show();
                $cache.productLoader.hide();

                reloadProductGrid();
                initializeProductGrid();
            }
        }
    };
}(window.app = window.app || {}, jQuery));
